export const PHONE_NUMBER_REGEX =
  /^[\+]?([(][0-9]{3}[)])?(([0-9]{1,4}[-]{1}[0-9]{1,4}){1,2}|[0-9-\s]{8,20})$/;
